import React, { Suspense } from "react";
import { useTranslation } from "react-i18next";
import CatalogueMainProducts from "~/modules/catalogue/components/CatalogueMainProducts";
import { InternalView } from "~/components/internal-view/internal-view";
import styles from "./partner.module.css";
import { Await, useLoaderData, useOutletContext } from "@remix-run/react";
import FloatingButtonCart from "~/modules/catalogue/components/FloattingButtonCart/FloatingButtonCart";
import { useCart } from "~/modules/cart/providers/cart.provider";
import { useGlobalStyles } from "~/styles/context/global-styles-wrapper";
import { WidgetCaller, WidgetType } from "@commons-monorepo/index";

export default function Index() {
  const { paginatedData } = useLoaderData();
  const { t } = useTranslation();
  const { theme } = useGlobalStyles();
  const { storeMetadata } = useOutletContext<any>();
  const { cartProducts, removeProduct, manuallyChangeProduct, addProduct } =
  useCart();
  const cart = {
    cartProducts,
    removeProduct,
    manuallyChangeProduct,
    addProduct
  };
  const localConfig = {
    cart: cart,
    locale: storeMetadata?.locale,
    currency: storeMetadata?.currency
  };

  return (
    <div className={styles.wrapperContainer}>
      <InternalView
        copy={t("sliderTexts.title_wholesale")}
        breadcrumbs={[{ text: t("sliderTexts.wholesale") }]}>

        {cartProducts.length >= 1 && <FloatingButtonCart />}
        <Suspense fallback={<></>}>
          <Await
            resolve={paginatedData}
            errorElement={<p>Error loading package location!</p>}>

            {(pd) =>
            <div className={styles.categoryGrid}>
                <CatalogueMainProducts
                data={pd?.products}
                theme={theme}
                localConfig={localConfig}
                caller={WidgetCaller.CatalogueInternal}
                storeMetadata={storeMetadata}
                type={WidgetType.PRODUCTS_GRID_1}
                config={{ highlight_background: false }} />

              </div>}

          </Await>
        </Suspense>
      </InternalView>
    </div>);

}